import React from 'react';
import { connect } from 'react-redux';
import ListItem from 'components/ListItem';
import { createStructuredSelector } from 'reselect';
import { AppState } from 'services/types';
import { ProductId } from 'services/products/types';
import {
    SprayEntityIds,
    SprayProduct,
    SprayApplicationRate
} from 'services/sprayEvents/types';
import { UnitTypeId } from 'services/unitTypes/types';
import { makeSelectProductTotal } from '../../../../../ProductPage/components/ProductDetails/components/ProductTotalListItem/selectors';

export interface OwnProps {
    productId: ProductId;
    entityIds: SprayEntityIds;
    product: SprayProduct;
    unitTypeId: UnitTypeId;
    applicationRate: SprayApplicationRate;
    needHalfCalculation: boolean;
}

export interface ConnectedProps {
    productTotal: string;
}

type Props = OwnProps & ConnectedProps;

export class SummaryProductTotalListItemComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { productTotal } = this.props;

        return <ListItem description="Product total" value={productTotal} />;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    productTotal: makeSelectProductTotal()
});

export default connect(mapStateToProps)(SummaryProductTotalListItemComponent);
